var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8898 15.8091C15.1436 16.0629 15.5552 16.0629 15.809 15.8091C16.0628 15.5552 16.0628 15.1437 15.809 14.8898L10.9192 9.99999L15.809 5.11016C16.0629 4.85632 16.0629 4.44476 15.809 4.19092C15.5552 3.93708 15.1436 3.93708 14.8898 4.19092L9.99994 9.08075L5.11011 4.19092C4.85627 3.93708 4.44471 3.93708 4.19087 4.19092C3.93703 4.44476 3.93703 4.85632 4.19087 5.11016L9.0807 9.99999L4.19087 14.8898C3.93703 15.1437 3.93703 15.5552 4.19087 15.8091C4.44472 16.0629 4.85627 16.0629 5.11011 15.8091L9.99994 10.9192L14.8898 15.8091Z",
    fill: "#151F29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlack);
export default __webpack_public_path__ + "static/media/cross-black.95e94e3032c2e335eb3b55334011d028.svg";
export { ForwardRef as ReactComponent };